<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'TaxPayerMonitoring'}">
              <h4 class="ms-2">
                {{label.pages.taxPayer}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row class="my-4 text-center">
            <b-col lg="4" md="6" sm="12">
              <p class="mb-0 fs-normal fw2 lh1">
                <b-icon icon="receipt" scale="2" class="ms-2" />
                مجموع صورت حساب های ثبت شده :
                <strong class="fs-medium">{{ item.invoiceCount }}</strong> عدد
              </p>
            </b-col>
            <b-col lg="4" md="6" sm="12">
              <p class="mb-0 fs-normal fw2 lh1">
                <b-icon icon="building" scale="2" class="ms-2" />
                مجموع شرکت‌های عضو سامانه مؤدیان :
                <strong class="fs-medium">{{ item.companyCount }}</strong> عدد
              </p>
            </b-col>
            <b-col lg="4" md="6" sm="12">
              <p class="mb-0 fs-normal fw2 lh1">
                <b-icon icon="people-fill" scale="2" class="ms-2" />
                تعداد کل کاربران عضو شده در وبسایت:
                <strong class="fs-medium">{{ item.userCount }}</strong> نفر
              </p>
            </b-col>
          </b-row>

          <b-row class="mt-5">
            <b-col cols="12">
              <Bar
                :chart-data="chartData"
                :chart-option="chartOptions"
                :height="180"
                :width="500"
               />
            </b-col>
          </b-row>

        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { Bar } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, LineElement, PointElement } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement, LineElement, PointElement)
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'TaxPayerMonitoring',
  components: {
    Bar,
  },
  data() {
    return {
      label,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    ...mapGetters({
      item: 'operationX/taxDashboard',
      chartData: 'operationX/taxDashboardChart',
    }),
  },
  beforeCreate() {
    this.$store.dispatch('operationX/getTaxDashboard');
  },
}
</script>
